import { useDispatch } from 'react-redux';
import { AnyAction, ThunkDispatch, unwrapResult } from '@reduxjs/toolkit';

import { artworksActions } from '@modules/artworks';
import { groupingArtworksActions } from '@modules/groupingArtworks';
import { RequestAddFavoritePayload } from '@definitions/artworks.types';
import { GlobalState } from '@modules/createStore';
import { tradeArtworksActions } from '@modules/tradeArtworks';

type AppDispatch = ThunkDispatch<GlobalState, any, AnyAction>;

export const useFavorite = () => {
  const dispatch: AppDispatch = useDispatch();

  const addFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(artworksActions.addToFavorite(data)).then(unwrapResult);

  const removeFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(artworksActions.removeFromFavorite(data)).then(unwrapResult);

  return { addFavorite, removeFavorite };
};

export const useGroupingFavorite = () => {
  const dispatch: AppDispatch = useDispatch();

  const addGroupingFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(groupingArtworksActions.addToFavorite(data)).then(unwrapResult);

  const removeGroupingFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(groupingArtworksActions.removeFromFavorite(data)).then(unwrapResult);

  return { addGroupingFavorite, removeGroupingFavorite };
};

export const useTradeFavorite = () => {
  const dispatch: AppDispatch = useDispatch();

  const addTradeFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(tradeArtworksActions.addToFavorite(data)).then(unwrapResult);

  const removeTradeFavorite = (data: RequestAddFavoritePayload) =>
    dispatch(tradeArtworksActions.removeFromFavorite(data)).then(unwrapResult);

  return { addTradeFavorite, removeTradeFavorite };
};
